// Helpers for the display-only pooling table under Instrument Limits.
//
// That table has its own "Selection for Pooling" (Y/N per instrument), which is
// independent of the Assign-for-Pooling table above it and persisted per
// location|method|sampleName|parameter in the `settings` collection.
// Dependency-free so it can be unit-tested without Firebase.

export const INSTRUMENT_POOLING_DISPLAY_TYPE = 'INSTRUMENT_POOLING_DISPLAY';

export function buildPoolingDisplayKey({ location, method, sampleName, parameter }) {
  const parts = [location, method, sampleName, parameter];
  return parts.every(Boolean) ? parts.join('|') : '';
}

// Firestore doc ids cannot contain '/', which method/sample names sometimes do.
export function poolingDisplayDocId(key) {
  return key ? `${INSTRUMENT_POOLING_DISPLAY_TYPE}_${encodeURIComponent(key)}` : '';
}

// Every current instrument defaults to 'Y'; saved 'Y'/'N' values win.
export function resolvePoolingSelections(instruments, saved = {}) {
  const selections = {};
  instruments.forEach((instrument) => {
    const value = saved?.[instrument];
    selections[instrument] = value === 'Y' || value === 'N' ? value : 'Y';
  });
  return selections;
}

// RSD (CV) as SD / |mean| x 100 to 2 dp; only a zero or non-numeric mean/SD is N/A.
// (null/'' are treated as missing rather than coerced to 0.)
export function formatRsd(mean, stdDev) {
  const toNumber = (v) => (v === null || v === '' ? NaN : Number(v));
  const m = toNumber(mean);
  const s = toNumber(stdDev);
  return Number.isFinite(m) && Number.isFinite(s) && m !== 0
    ? ((s / Math.abs(m)) * 100).toFixed(2)
    : 'N/A';
}
